import { quickOrderService } from '@/services/quick-order.service';
import { useMutation } from '@tanstack/react-query';
import { AddProduct } from '@/types/quick-order';

export const useGetProductByCatalogId = () => {
  return useMutation({
    mutationFn: (catalogNumber: string) => quickOrderService.getProductByCatalogId(catalogNumber?.trim().toUpperCase()),
  });
};

export const useAddBatchToCart = () => {
  return useMutation({
    mutationFn: (products: AddProduct[]) => quickOrderService.addBatchToCart(products),
  });
};
export const useMutationQuickOrderUpload = () => {
  return useMutation((file) => {
    return quickOrderService.uploadQuickOrder(file);
  });
};
